<template>
  <div class="content">
    <div class="left">{{title}}</div>
    <!-- <div class="right" @click="isShowContact = !isShowContact">
      <img src="@/assets/img/open/icon_wechat.png" alt="">
      <div class="font">联系客服</div>
      
      <div class="position">
        <Contact v-show="isShowContact"></Contact>
      </div>
    </div> -->
    

  </div>
</template>

<script>
import Contact from '@/components/Contact'

export default {
  name: '',
  components: {Contact},
  props: ['title'],
  data() {
    return {
      isShowContact:false
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  destroyed() {},
  methods: {}
}
</script>
<style lang='less' scoped>
.content {
  // display: flex;
  // justify-content: space-between;

  .left {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/user/components/title.vue